import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useUser } from "../contexts/UserContext";
import { useBusiness } from "../contexts/BusinessContext";
import { appInfo } from "../config/appInfo.const";
import { logout as authLogout } from "../services/authService";
import FeatherIcon from 'feather-icons-react';
interface HeaderProps {
   onToggleSidebar: () => void;
}
export default function Header({ onToggleSidebar }: HeaderProps) {
   const { user} = useUser();
   const { business } = useBusiness();
   
   const handleLogout = async () => {
      await authLogout();
   };
   
   return (
      <>
         <nav className="navbar fixed-top navbar-expand bg-navbar">
            <a id="sidebar-toggle" className="sidebar-toggle" onClick={onToggleSidebar}>
               <i className="hamburger align-self-center"></i>
            </a>
            <a href="" className="navbar-brand top-navbar-brand text-light">
               {business?.name || appInfo.appName}
            </a>
            <div className="navbar-collapse collapse">
               <ul className="navbar-nav navbar-align">
                  <li className="nav-item">
                     <Dropdown align="end">
                        <Dropdown.Toggle as="span" id="alertsDropdown" className="nav-icon pointer">
                           <div className="position-relative">
                              <FeatherIcon icon="bell" />
                              <span className="indicator">4</span>
                           </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-lg py-0 nav-dropdown">
                           <div className="dropdown-menu-header">4 New Notifications</div>
                           <div className="list-group">
                              <Dropdown.Item as="div" className="list-group-item">
                                 <div className="row g-0 align-items-center">
                                    <div className="col-2">
                                       <i className="text-danger" data-feather="alert-circle"></i>
                                    </div>
                                    <div className="col-10">
                                       <div className="text-dark">Update completed</div>
                                       <div className="text-muted small mt-1">Restart server 12 to complete the update.</div>
                                       <div className="text-muted small mt-1">30m ago</div>
                                    </div>
                                 </div>
                              </Dropdown.Item>
                              {/* repeat for other notifications */}
                           </div>
                           <div className="dropdown-menu-footer">
                              <a href="#" className="text-muted">Show all notifications</a>
                           </div>
                        </Dropdown.Menu>
                     </Dropdown>
                  </li>
                  <li className="nav-item">
                     <Dropdown align="end">
                        <Dropdown.Toggle as="span" id="messagesDropdown" className="nav-icon pointer">
                           <div className="position-relative">
                              <FeatherIcon icon="message-square" />
                           </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-lg py-0 nav-dropdown">
                           <div className="dropdown-menu-header">4 New Messages</div>
                           <div className="list-group">
                              <Dropdown.Item as="div" className="list-group-item">
                                 <div className="row g-0 align-items-center">
                                    <div className="col-2">
                                       <img
                                          src="dboard/img/avatars/avatar-5.jpg"
                                          className="avatar img-fluid rounded-circle"
                                          alt="Vanessa Tucker"
                                       />
                                    </div>
                                    <div className="col-10 ps-2">
                                       <div className="text-dark">Vanessa Tucker</div>
                                       <div className="text-muted small mt-1">Nam pretium turpis et arcu.</div>
                                       <div className="text-muted small mt-1">15m ago</div>
                                    </div>
                                 </div>
                              </Dropdown.Item>
                              {/* repeat for other messages */}
                           </div>
                           <div className="dropdown-menu-footer">
                              <a href="#" className="text-muted">Show all messages</a>
                           </div>
                        </Dropdown.Menu>
                     </Dropdown>
                  </li>
                  <li className="nav-item">
                     <Dropdown align="end">
                        <Dropdown.Toggle
                           as="span"
                           id="profileDropdown"
                           className="nav-link dropdown-toggle pointer"
                        >
                           <img
                              src="dboard/img/avatars/avatar.jpg"
                              className="avatar img-fluid rounded me-1"
                              alt="Charles Hall"
                           />{" "}
                           <span className="text-light">{user?.name}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="nav-dropdown">
                           <Dropdown.Item as={Link} to="/profile">
                              <i className="align-middle me-1" data-feather="user"></i> Profile
                           </Dropdown.Item>
                           <Dropdown.Item href="#">
                              <i className="align-middle me-1" data-feather="pie-chart"></i> Analytics
                           </Dropdown.Item>
                           <Dropdown.Divider />
                           <Dropdown.Item href="index.html">
                              <i className="align-middle me-1" data-feather="settings"></i> Settings & Privacy
                           </Dropdown.Item>
                           <Dropdown.Item href="#">
                              <i className="align-middle me-1" data-feather="help-circle"></i> Help Center
                           </Dropdown.Item>
                           <Dropdown.Divider />
                           <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                     </Dropdown>
                  </li>
               </ul>
            </div>
         </nav>
      </>
   );
}
